import BootstrapSelect from 'react-bootstrap-select-dropdown';
import { useForm } from 'react-hook-form';
import { useCreateTeam, useGetHospitalAllClinicians } from '../hooks';
import { useEffect } from 'react';
import { translateCliniciansToOptions } from '../helpers/translateCliniciansToOptions';
import Select from 'react-select';

export const CreateTeamForm = ({
  selectedHospitalIds,
  clinics,
  setToast,
  reloadTeams,
}) => {
  const { postCreateTeam, isLoading } = useCreateTeam();
  const {
    postGetHospitalAllClinicians,
    cliniciansByHospital,
    isLoading: isLoadingAllClinicians,
  } = useGetHospitalAllClinicians();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, value },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      team_name: '',
      staff_ids: [],
      manual_input_hopsital: [],
    },
  });

  const manual_input_hopsital = watch('manual_input_hopsital');
  const staff_ids = watch('staff_ids');

  const handleCreateTeam = async (values) => {
    const staff_ids = values.staff_ids.map((item) => item.value);
    setToast('Creating team..');
    await postCreateTeam({
      team_name: values.team_name,
      hospital_id:
        selectedHospitalIds.length === 1
          ? selectedHospitalIds[0]
          : manual_input_hopsital[0],
      staff_ids: staff_ids,
    });
    reloadTeams();
    setToast('Team created!');
    reset();
  };

  useEffect(() => {
    if (selectedHospitalIds.length === 1) {
      postGetHospitalAllClinicians([selectedHospitalIds[0]]);
    } else if (manual_input_hopsital.length > 0) {
      postGetHospitalAllClinicians([manual_input_hopsital[0]]);
    }
    setValue('staff_ids', []);
  }, [selectedHospitalIds, manual_input_hopsital]);

  const cliniciansOptions =
    Array.isArray(cliniciansByHospital) && cliniciansByHospital[0]
      ? translateCliniciansToOptions(cliniciansByHospital[0].clinicians)
      : [];

  const clinicsOptions = Array.isArray(clinics)
    ? clinics.map((clinic) => {
        return {
          labelKey: clinic.clinic_id,
          value: clinic.clinic,
        };
      })
    : [];

  return (
    <>
      <form>
        <div className="create-team-form">
          <div>
            <label className="txtDropdownLabel">
              Enter the name of the team
            </label>
            <div>
              <input
                required
                placeholder="Enter the name"
                type="text"
                autoComplete="off"
                {...register('team_name')}
              />
            </div>
          </div>
          <div className="mt-2">
            {selectedHospitalIds.length > 1 ? (
              <>
                <label className="txtDropdownLabel">Select hospital</label>
                <div className="divSelect">
                  <BootstrapSelect
                    style={{ width: '350px' }}
                    isMultiSelect={false}
                    menuSize={800}
                    options={clinicsOptions}
                    placeholder={'Select'}
                    showTick={true}
                    onChange={(selectedOptions) =>
                      setValue(
                        'manual_input_hopsital',
                        selectedOptions.selectedKey,
                      )
                    }
                  />
                </div>
              </>
            ) : null}
          </div>
          <div className="mt-2">
            <label className="txtDropdownLabel">
              Select staff to add this team
            </label>
            <div className="divSelect">
              <div style={{ width: '350px' }}>
                <Select
                  isMulti
                  menuSize={800}
                  options={!isLoadingAllClinicians ? cliniciansOptions : []}
                  placeholder={'Type or search through names'}
                  showTick={true}
                  onChange={(selectedOptions) => {
                    setValue('staff_ids', selectedOptions);
                  }}
                  clearValue={() => {
                    setValue('staff_ids', []);
                  }}
                  value={staff_ids}
                  isDisabled={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-3">
          <button
            disabled={isLoading}
            type="button"
            className="btn btnPrimary btn-md btn-xlong"
            onClick={handleSubmit(handleCreateTeam)}
          >
            Create
          </button>
        </div>
      </form>
    </>
  );
};
